module.exports = __webpack_public_path__ + "img/any-num7.52354b06.png";